export default __webpack_public_path__ + "static/media/kinderLogo.7fccffa3.png";